import 'css-chunksrc/client/scenes/optimizedGantt/header/workloadsToggle/styles.scss';export default {
  "workloadsToggle": "_workloadsToggle_1jxnu_1",
  "icon": "_icon_1jxnu_10",
  "text": "_text_1jxnu_16"
};